import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { GetVirtualCardPaymentDetailsUseCase } from './GetVirtualCardPaymentDetailsUseCase'

export const getVirtualCardPaymentDetailsUseCase =
  new GetVirtualCardPaymentDetailsUseCase({
    cardRepository,
  }).execute
